import React from 'react';
import PropTypes from 'prop-types';
import { QuoteInstallationOptionSummary } from '../../../quotes/quoteInstallationInformation';
import { formatPrice } from '../../../quotes/priceFormatter';
import classNames from 'classnames';

export default class ReviewQuoteInstallationOption extends React.PureComponent {
  static propTypes = {
    installationOption: PropTypes.instanceOf(QuoteInstallationOptionSummary)
      .isRequired,
    msrpClassNames: PropTypes.string.isRequired,
    dNetClassNames: PropTypes.string.isRequired,
    selectedPriceMode: PropTypes.string.isRequired,
    isoCurrencySymbol: PropTypes.string.isRequired,
  };

  render() {
    const option = this.props.installationOption;

    const {
      msrpClassNames,
      dNetClassNames,
      selectedPriceMode,
      isoCurrencySymbol,
    } = this.props;
    const isMsrpOnly = selectedPriceMode === 'msrpOnly';
    return (
      <tr>
        <td data-title="" className="text-start">
          {option.name}
          <br />
          {option.partNumber}
          <div className="mt-2 text-break-line">{option.description}</div>
        </td>
        <td className="price-breakdown">
          <div className="row price-heading-mobile">
            <div className="col-6"></div>
            <div className={classNames('price-heading', msrpClassNames)}>
              MSRP
            </div>
            <div className={classNames('price-heading', dNetClassNames)}>
              D. NET
            </div>
          </div>
          {option.discountPercentage > 0 && !isMsrpOnly && (
            <div className="row">
              <div className="col-6">Base price</div>
              <div className={msrpClassNames}>{formatPrice(option.msrp)}</div>
              <div className={dNetClassNames}>
                {formatPrice(option.dNetPrice)}
              </div>
            </div>
          )}
          {option.discountPercentage > 0 && !isMsrpOnly && (
            <div className="row">
              <div className="col-6">{`Dealer Discount (${option.discountPercentage}%)`}</div>
              <div className={msrpClassNames}>N/A</div>
              <div className={dNetClassNames}>
                {formatPrice(option.getDealerDiscount() * -1)}
              </div>
            </div>
          )}
          <div className="row unit-price">
            <div className="col-6">Unit Price</div>
            <div className={msrpClassNames}>{formatPrice(option.msrp)}</div>
            <div className={dNetClassNames}>
              {formatPrice(option.getUnitPrice())}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Quantity</div>
            <div className="col-3 text-center">{option.quantity}</div>
          </div>
          <div className="row total-price">
            <div className="col-6">Total ({isoCurrencySymbol})</div>
            <div className={msrpClassNames}>
              {formatPrice(option.getTotalMsrp())}
            </div>
            <div className={dNetClassNames}>
              {formatPrice(option.getTotal())}
            </div>
          </div>
        </td>
      </tr>
    );
  }
}
